/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  useCallback,
  useState,
} from 'react';
import type {
  ReactElement,
  ReactNode,
} from 'react';

import styled from 'styled-components';

import { Modal } from '../Modal';

export const StyledButton = styled.button(({
  disabled,

  theme: {
    colors,
  },
}) => ({
  cursor: disabled ? undefined : 'pointer',
  textAlign: 'center',
  color: disabled ? colors.NEUTRAL_INACTIVE : colors.NEUTRAL_INPUT,
  backgroundColor: 'transparent',
  padding: 0,
  border: 'none',
  outline: 'none',

  '&:hover': disabled ? undefined : {
    color: colors.ACTION_HOVER,
  },

  '&:active': disabled ? undefined : {
    color: colors.ACTION_PRESSED,
  },
}));

export type ModalSelectButtonModalRenderProps<ValueType> = {
  onCancel: () => void;
  onSelect: (nextValue: ValueType) => void;
};

export type ModalSelectButtonProps<ValueType> = {
  className?: string;
  disabled?: boolean;
  onSelectFromModal?: (nextValue: ValueType) => void;

  /**
   * Функция рендера содержимого модального окна
   */
  renderModal: (renderProps: ModalSelectButtonModalRenderProps<ValueType>) => ReactNode;
};

export function ModalSelectButton<ValueType>({
  className = '',
  disabled = false,
  onSelectFromModal: onSelectFromModalProp = undefined,
  renderModal,
}: ModalSelectButtonProps<ValueType>): ReactElement {
  const [isOpened, setIsOpened] = useState<boolean>(false);

  const openModal = useCallback(() => {
    if (disabled) {
      return;
    }

    setIsOpened(true);
  }, [disabled]);

  const closeModal = useCallback(
    () => {
      setIsOpened(false);
    },
    [],
  );

  const onSelectFromModal = useCallback(
    (value: ValueType) => {
      setIsOpened(false);

      if (onSelectFromModalProp) {
        onSelectFromModalProp(value);
      }
    },
    [onSelectFromModalProp],
  );

  return (
    <>
      <StyledButton
        type="button"
        className={className}
        disabled={disabled}
        onClick={openModal}
      >
        <svg
          width={16}
          height={16}
          viewBox="0 0 16 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 5.33333V4H14V5.33333H2ZM2 8.66667H14V7.33333H2V8.66667ZM2 12H14V10.6667H2V12Z"
          />
        </svg>
      </StyledButton>

      <Modal
        show={isOpened}
        onHide={closeModal}
      >
        {renderModal({
          onCancel: closeModal,
          onSelect: onSelectFromModal,
        }) as ReactElement}
      </Modal>
    </>
  );
}
